import { Carousel, FlexContainer, Layout, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { ImgUrls, SlidersMode, sliderItems } from './type';

const DgSlider = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  return (
    <Carousel
      hasAutoplay
      autoplayDelay={7000}
      autoplayPauseOnMouseEnter
      items={sliderItems?.map(key => (
        <Layout.Wrap size="M" mode={SlidersMode[key.type]} hasBorder fullWidth>
          <FlexContainer direction="column" align="center" justify="center" gap="dimension_08">
            <Text type="paragraphs" align="center" size="L_L_M" color="cold">
              {t(`Slider.title.${key.type}`)}
            </Text>
            <Text type="paragraphs" align="center" size="XS_M_M" color="cold">
              {t(`Slider.description.${key.type}`)}
            </Text>
            <img src={ImgUrls[key.type]} alt={key.type} />
          </FlexContainer>
        </Layout.Wrap>
      ))}
    />
  );
};

export default DgSlider;
